/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One admission's demographics as read from MatrixCare.
 * @export
 * @interface MatrixCareAdmissionDemographics
 */
export interface MatrixCareAdmissionDemographics {
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    first_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    middle_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    last_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    suffix?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    nickname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    preferred_pronouns?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    medical_record?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    formatted_ssn?: string | null;
    /**
     * MatrixCare wire format, M/D/YYYY.
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    date_of_birth?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    address_line?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    apt_or_suite?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    city?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    state_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    zip_code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    country?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    email?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    home_phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    mobile_phone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    gender?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    gender_identity?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    sexual_orientation?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    lives_alone?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    marital_status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    religion?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixCareAdmissionDemographics
     */
    races: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof MatrixCareAdmissionDemographics
     */
    ethnicities: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    referral_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    scheduled_soc_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    physician_ordered_soc_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    facility_discharge_date?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    facility_discharge_type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareAdmissionDemographics
     */
    referral_source?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareAdmissionDemographics
     */
    is_short_stay_acute_hospital?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareAdmissionDemographics
     */
    for_observation_only?: boolean | null;
}

/**
 * Check if a given object implements the MatrixCareAdmissionDemographics interface.
 */
export function instanceOfMatrixCareAdmissionDemographics(value: object): value is MatrixCareAdmissionDemographics {
    if (!('races' in value) || value['races'] === undefined) return false;
    if (!('ethnicities' in value) || value['ethnicities'] === undefined) return false;
    return true;
}

export function MatrixCareAdmissionDemographicsFromJSON(json: any): MatrixCareAdmissionDemographics {
    return MatrixCareAdmissionDemographicsFromJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareAdmissionDemographics {
    if (json == null) {
        return json;
    }
    return {
        
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'middle_name': json['middle_name'] == null ? undefined : json['middle_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'preferred_pronouns': json['preferred_pronouns'] == null ? undefined : json['preferred_pronouns'],
        'medical_record': json['medical_record'] == null ? undefined : json['medical_record'],
        'formatted_ssn': json['formatted_ssn'] == null ? undefined : json['formatted_ssn'],
        'date_of_birth': json['date_of_birth'] == null ? undefined : json['date_of_birth'],
        'address_line': json['address_line'] == null ? undefined : json['address_line'],
        'apt_or_suite': json['apt_or_suite'] == null ? undefined : json['apt_or_suite'],
        'city': json['city'] == null ? undefined : json['city'],
        'state_code': json['state_code'] == null ? undefined : json['state_code'],
        'zip_code': json['zip_code'] == null ? undefined : json['zip_code'],
        'country': json['country'] == null ? undefined : json['country'],
        'email': json['email'] == null ? undefined : json['email'],
        'home_phone': json['home_phone'] == null ? undefined : json['home_phone'],
        'mobile_phone': json['mobile_phone'] == null ? undefined : json['mobile_phone'],
        'gender': json['gender'] == null ? undefined : json['gender'],
        'gender_identity': json['gender_identity'] == null ? undefined : json['gender_identity'],
        'sexual_orientation': json['sexual_orientation'] == null ? undefined : json['sexual_orientation'],
        'lives_alone': json['lives_alone'] == null ? undefined : json['lives_alone'],
        'marital_status': json['marital_status'] == null ? undefined : json['marital_status'],
        'religion': json['religion'] == null ? undefined : json['religion'],
        'races': json['races'],
        'ethnicities': json['ethnicities'],
        'referral_date': json['referral_date'] == null ? undefined : json['referral_date'],
        'scheduled_soc_date': json['scheduled_soc_date'] == null ? undefined : json['scheduled_soc_date'],
        'physician_ordered_soc_date': json['physician_ordered_soc_date'] == null ? undefined : json['physician_ordered_soc_date'],
        'facility_discharge_date': json['facility_discharge_date'] == null ? undefined : json['facility_discharge_date'],
        'facility_discharge_type': json['facility_discharge_type'] == null ? undefined : json['facility_discharge_type'],
        'referral_source': json['referral_source'] == null ? undefined : json['referral_source'],
        'is_short_stay_acute_hospital': json['is_short_stay_acute_hospital'] == null ? undefined : json['is_short_stay_acute_hospital'],
        'for_observation_only': json['for_observation_only'] == null ? undefined : json['for_observation_only'],
    };
}

export function MatrixCareAdmissionDemographicsToJSON(json: any): MatrixCareAdmissionDemographics {
    return MatrixCareAdmissionDemographicsToJSONTyped(json, false);
}

export function MatrixCareAdmissionDemographicsToJSONTyped(value?: MatrixCareAdmissionDemographics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'first_name': value['first_name'],
        'middle_name': value['middle_name'],
        'last_name': value['last_name'],
        'suffix': value['suffix'],
        'nickname': value['nickname'],
        'preferred_pronouns': value['preferred_pronouns'],
        'medical_record': value['medical_record'],
        'formatted_ssn': value['formatted_ssn'],
        'date_of_birth': value['date_of_birth'],
        'address_line': value['address_line'],
        'apt_or_suite': value['apt_or_suite'],
        'city': value['city'],
        'state_code': value['state_code'],
        'zip_code': value['zip_code'],
        'country': value['country'],
        'email': value['email'],
        'home_phone': value['home_phone'],
        'mobile_phone': value['mobile_phone'],
        'gender': value['gender'],
        'gender_identity': value['gender_identity'],
        'sexual_orientation': value['sexual_orientation'],
        'lives_alone': value['lives_alone'],
        'marital_status': value['marital_status'],
        'religion': value['religion'],
        'races': value['races'],
        'ethnicities': value['ethnicities'],
        'referral_date': value['referral_date'],
        'scheduled_soc_date': value['scheduled_soc_date'],
        'physician_ordered_soc_date': value['physician_ordered_soc_date'],
        'facility_discharge_date': value['facility_discharge_date'],
        'facility_discharge_type': value['facility_discharge_type'],
        'referral_source': value['referral_source'],
        'is_short_stay_acute_hospital': value['is_short_stay_acute_hospital'],
        'for_observation_only': value['for_observation_only'],
    };
}

